import { render, staticRenderFns } from "./student-top-statistics.vue?vue&type=template&id=5ee2e18d&scoped=true"
import script from "./student-top-statistics.vue?vue&type=script&lang=js"
export * from "./student-top-statistics.vue?vue&type=script&lang=js"
import style0 from "./student-top-statistics.vue?vue&type=style&index=0&id=5ee2e18d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee2e18d",
  null
  
)

export default component.exports